import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";
import { Draggable } from "react-beautiful-dnd";
import QuickListGroupList from "./QuickListGroupList";

const grid = 8;
const borderRadius = 3;
const colors = {
  G50: "white",
  N30: "lightgray",
  T50: "blue",
  P100: "purple",
};

const Container = styled.div`
  margin: ${grid}px;
  display: inline-flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  font-weight: 600;
  border-top-left-radius: ${borderRadius}px;
  border-top-right-radius: ${borderRadius}px;
  background-color: ${colors.N30};
  transition: background-color 0.2s ease;
`;

const Title = styled.div`
flex-grow: 1;
user-select: none;
position: relative;
overflow: hidden;
&:focus {
  outline: 2px solid ${colors.P100};
  outline-offset: 2px;
}
`;

const QuickListColumn = props => {

  const getDraggableContent = (provided, snapshot) => (
      <Container className={"column"}
        ref={provided.innerRef}
        {...provided.draggableProps}>
        <Header>
          <Title className={"header"}>
            {props.title}
          </Title>
        </Header>
        <QuickListGroupList
          listId={props.title}
          listType="QUOTE"
          style={{ backgroundColor: snapshot.isDragging ? colors.G50 : null }}
          quotes={props.items}
        />
      </Container>
    );


  return (
    <Draggable 
      draggableId={"column" + props.index} 
      index={props.index}
      children={getDraggableContent}
    />
  );
  
};

QuickListColumn.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  index: PropTypes.number.isRequired,
};
export default QuickListColumn;
